import { pagePath } from '@/utils/router/pagePath';
/**
 * コンサルのデータを UserBox に適した形式に変換
 */
export const formatProfessionalDataToUserBox = (professional) => ({
    extraTexts: [
        {
            link: professional.url_code
                ? pagePath.consultantUnit.detail(professional.url_code)
                : '',
            text: professional.professional_organization_name,
        },
    ],
    firstName: professional.first_name,
    id: professional.id,
    imageSrc: professional.image_src || '',
    isShowDetailPage: professional.has_professional_detail_page,
    lastName: professional.last_name,
    professionalType: professional.professional_type,
});
